import React from "react";
import {List} from "../modules/Organisations";

export function OrganisationListPage() {
  return (
    <List />
  );
}
